import { Heart, Sparkles } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { useState } from "react";

export function VerseBlock({ v, index = 0 }) {
  const { user } = useAuth();
  const [saved, setSaved] = useState(false);

  const fav = async () => {
    if (!user) { toast.error("Log in to save favorite Proverbs."); return; }
    try { await api.post("/favorites", { verse_id: v.id }); setSaved(true); toast.success("Saved to favorites."); }
    catch { toast.error("Could not save."); }
  };

  return (
    <article data-testid={`verse-block-${index}`} className="animate-fade-up" style={{ animationDelay: `${index * 60}ms` }}>
      <div className="rounded-2xl border border-[#E2E8F0] bg-white overflow-hidden">
        <div className="flex items-start justify-between gap-3 px-6 pt-6">
          <div className="text-xs uppercase tracking-widest text-[#B8912F] font-semibold">{v.reference} · {v.translation}</div>
          <button data-testid={`fav-btn-${index}`} onClick={fav} className="shrink-0 text-[#94A3B8] hover:text-[#2C4C3B] transition-colors">
            <Heart className={`w-5 h-5 ${saved ? "fill-[#2C4C3B] text-[#2C4C3B]" : ""}`} />
          </button>
        </div>
        {/* Scripture */}
        <div className="px-6 py-4">
          <div className="bg-[#F9F7F1] border-l-2 border-[#B8912F] rounded-r-lg px-5 py-4">
            <p className="font-serif-display italic text-xl sm:text-2xl leading-relaxed text-[#0F172A]">"{v.text}"</p>
          </div>
        </div>
        <div className="px-6 pb-6 space-y-4">
          {v.explanation && <Field label="What this means" text={v.explanation} />}
          {v.application && <Field label="What this means for you today" text={v.application} accent />}
          {v.prayer && (
            <div className="rounded-xl bg-[#2C4C3B] px-5 py-4">
              <div className="text-[10px] uppercase tracking-widest text-[#D4C48A] font-semibold mb-1.5">A short prayer</div>
              <p className="font-serif-display italic text-lg text-white/95 leading-relaxed">{v.prayer}</p>
            </div>
          )}
          {v.related && v.related.length > 0 && (
            <div className="flex flex-wrap items-center gap-2 pt-1">
              <span className="text-xs text-[#94A3B8]">Related:</span>
              {v.related.map((r) => <span key={r} className="text-xs px-2.5 py-1 rounded-full bg-[#F4F1EA] text-[#475569]">{r}</span>)}
            </div>
          )}
        </div>
      </div>
    </article>
  );
}

function Field({ label, text, accent }) {
  return (
    <div>
      <div className={`text-[10px] uppercase tracking-widest font-semibold mb-1 flex items-center gap-1.5 ${accent ? "text-[#2C4C3B]" : "text-[#94A3B8]"}`}>
        {accent && <Sparkles className="w-3 h-3" />}{label}
      </div>
      <p className="text-[15px] leading-relaxed text-[#334155]">{text}</p>
    </div>
  );
}
